import React from 'react'

const MedicineIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 510 510"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <linearGradient
                        id="e"
                        x1="13.429"
                        x2="399.355"
                        y1="111.631"
                        y2="497.557"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#fee97d" />
                        <stop offset={1} stopColor="#fe860a" />
                    </linearGradient>
                    <linearGradient id="a">
                        <stop offset={0} stopColor="#fe7701" stopOpacity={0} />
                        <stop offset=".398" stopColor="#e05915" stopOpacity=".398" />
                        <stop offset={1} stopColor="#ac2538" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#a"
                        id="f"
                        x1="186.459"
                        x2="186.459"
                        y1="192.059"
                        y2="-21.282"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#a"
                        id="g"
                        x1="170.802"
                        x2="170.802"
                        y1="464.733"
                        y2="516.247"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient id="b">
                        <stop offset={0} stopColor="#eaf6ff" />
                        <stop offset={1} stopColor="#b3dafe" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#b"
                        id="h"
                        x1="170.802"
                        x2="170.802"
                        y1="11.31"
                        y2="89.103"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient id="c">
                        <stop offset={0} stopColor="#d8ecfe" stopOpacity={0} />
                        <stop offset=".787" stopColor="#9bd1fe" stopOpacity=".787" />
                        <stop offset={1} stopColor="#8ac9fe" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#c"
                        id="i"
                        x1="170.802"
                        x2="170.802"
                        y1="3.55"
                        y2="94.041"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#c"
                        id="j"
                        x1="170.802"
                        x2="170.802"
                        y1="19.08"
                        y2="77.542"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#b"
                        id="k"
                        x1="97.427"
                        x2="296.559"
                        y1="326.085"
                        y2="326.085"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#c"
                        id="l"
                        x1="277.259"
                        x2="159.653"
                        y1="432.543"
                        y2="314.937"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        id="m"
                        x1="131.259"
                        x2="210.316"
                        y1="286.543"
                        y2="365.6"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#fd4755" />
                        <stop offset={1} stopColor="#d2024e" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#b"
                        id="n"
                        x1="1537.542"
                        x2="1537.542"
                        y1="-143.124"
                        y2="-30.884"
                        gradientTransform="rotate(45 408.803 -1250.169)"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#c"
                        id="o"
                        x1="1537.543"
                        x2="1537.543"
                        y1="-124.958"
                        y2="-74.47"
                        gradientTransform="rotate(45 408.803 -1250.169)"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient id="d">
                        <stop offset={0} stopColor="#26a6fe" />
                        <stop offset={1} stopColor="#2740b0" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#d"
                        id="p"
                        x1="1487.042"
                        x2="1487.042"
                        y1="-143.791"
                        y2="-71.779"
                        gradientTransform="rotate(45 408.803 -1250.169)"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#b"
                        id="q"
                        x1={409}
                        x2={409}
                        y1="437.333"
                        y2="549.573"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#c"
                        id="r"
                        x1={409}
                        x2={409}
                        y1="455.5"
                        y2="505.988"
                        gradientUnits="userSpaceOnUse"
                    />
                    <linearGradient
                        xlinkHref="#d"
                        id="s"
                        x1="358.5"
                        x2="358.5"
                        y1="436.667"
                        y2="508.679"
                        gradientUnits="userSpaceOnUse"
                    />
                    <path
                        fill="url(#e)"
                        d="M309.899 99.378V19.085H31.704v80.293a87.157 87.157 0 0 1-15.657 49.842A87.17 87.17 0 0 0 .39 199.063v11.783l5.402 108.038L.39 441.324v30.448C.39 492.885 17.505 510 38.618 510h264.368c21.112 0 38.227-17.115 38.227-38.227v-30.448l-5.402-122.441 5.402-108.038v-11.783a87.157 87.157 0 0 0-15.657-49.842 87.17 87.17 0 0 1-15.657-49.843z"
                        opacity={1}
                        data-original="url(#e)"
                        className="hovered-path"
                    />
                    <path
                        fill="url(#f)"
                        d="m339.485 402.149-3.674-83.266 5.402-108.037v-11.783a87.157 87.157 0 0 0-15.657-49.842 87.164 87.164 0 0 1-15.657-49.842V19.085H31.704v75.284z"
                        opacity={1}
                        data-original="url(#f)"
                    />
                    <path
                        fill="url(#g)"
                        d="m5.59 314.831.203 4.052L.39 441.324v30.448C.39 492.885 17.505 510 38.618 510h264.368c21.112 0 38.227-17.115 38.227-38.227v-30.448l-5.402-122.441.203-4.052H5.59z"
                        opacity={1}
                        data-original="url(#g)"
                    />
                    <path
                        fill="url(#h)"
                        d="M322.234 94.324H19.369C8.672 94.324 0 85.652 0 74.955V19.369C0 8.672 8.672 0 19.369 0h302.866c10.697 0 19.369 8.672 19.369 19.369v55.586c-.001 10.697-8.673 19.369-19.37 19.369z"
                        opacity={1}
                        data-original="url(#h)"
                    />
                    <path
                        fill="url(#i)"
                        d="M266.286 94.324H75.317c-8.627 0-15.621-6.994-15.621-15.621V15.621C59.696 6.994 66.69 0 75.317 0h190.969c8.627 0 15.621 6.994 15.621 15.621v63.081c0 8.628-6.994 15.622-15.621 15.622z"
                        opacity={1}
                        data-original="url(#i)"
                    />
                    <path
                        fill="url(#j)"
                        d="M197.829 94.324h-54.055a8.88 8.88 0 0 1-8.881-8.881V8.881A8.88 8.88 0 0 1 143.774 0h54.055a8.88 8.88 0 0 1 8.881 8.881v76.562a8.88 8.88 0 0 1-8.881 8.881z"
                        opacity={1}
                        data-original="url(#j)"
                    />
                    <path
                        fill="url(#k)"
                        d="M.39 210.846h340.823v230.479H.39z"
                        opacity={1}
                        data-original="url(#k)"
                    />
                    <path
                        fill="url(#l)"
                        d="M341.213 396.909 202.47 258.777c-1.961-4.711-6.605-8.025-12.027-8.025H153.16c-7.193 0-13.025 5.831-13.025 13.025v31.642h-31.642c-7.193 0-13.025 5.831-13.025 13.025v37.284c0 5.421 3.314 10.066 8.025 12.027l83.09 83.571h154.63z"
                        opacity={1}
                        data-original="url(#l)"
                    />
                    <path
                        fill="url(#m)"
                        d="M234.11 294.419h-31.642v-31.642c0-7.193-5.831-13.025-13.025-13.025H152.16c-7.193 0-13.025 5.831-13.025 13.025v31.642h-31.642c-7.193 0-13.025 5.831-13.025 13.025v37.284c0 7.193 5.831 13.025 13.025 13.025h31.642v31.642c0 7.193 5.831 13.025 13.025 13.025h37.284c7.193 0 13.025-5.831 13.025-13.025v-31.642h31.642c7.193 0 13.025-5.831 13.025-13.025v-37.284c-.001-7.194-5.832-13.025-13.026-13.025z"
                        opacity={1}
                        data-original="url(#m)"
                    />
                    <path
                        fill="url(#n)"
                        d="m408.293 417.418-70.711-70.711c-19.917-19.917-19.917-52.208 0-72.125s52.208-19.917 72.125 0l70.711 70.711c19.917 19.917 19.917 52.208 0 72.125s-52.208 19.917-72.125 0z"
                        opacity={1}
                        data-original="url(#n)"
                    />
                    <path
                        fill="url(#o)"
                        d="M337.582 274.582c-19.917 19.917-19.917 52.208 0 72.125l70.711 70.711c19.917 19.917 52.208 19.917 72.125 0a51.12 51.12 0 0 0 6.928-8.629L346.211 267.654a51.21 51.21 0 0 0-8.629 6.928z"
                        opacity={1}
                        data-original="url(#o)"
                    />
                    <path
                        fill="url(#p)"
                        d="m445.062 309.938-35.355-35.355c-19.917-19.917-52.208-19.917-72.125 0s-19.917 52.208 0 72.125l35.355 35.355z"
                        opacity={1}
                        data-original="url(#p)"
                    />
                    <path
                        fill="url(#q)"
                        d="M459 510H359c-28.167 0-51-22.833-51-51 0-28.166 22.833-51 51-51h100c28.167 0 51 22.833 51 51s-22.833 51-51 51z"
                        opacity={1}
                        data-original="url(#q)"
                    />
                    <path
                        fill="url(#r)"
                        d="M308 459c0 28.167 22.833 51 51 51h100c28.166 0 51-22.833 51-51 0-3.778-.423-7.456-1.203-11H309.203A51.113 51.113 0 0 0 308 459z"
                        opacity={1}
                        data-original="url(#r)"
                    />
                    <path
                        fill="url(#s)"
                        d="M409 408h-50c-28.167 0-51 22.833-51 51 0 28.166 22.833 51 51 51h50z"
                        opacity={1}
                        data-original="url(#s)"
                    />
                </g>
            </svg>

        </>
    )
}

export default MedicineIcon